"use client";

import { getDataAutomationId } from "@/helpers";
import SecondaryNavigationDesktop from "./Desktop/SecondaryNavigation";
import SecondaryNavigationMobile from "./Mobile/SecondaryNavigationMobile";
import { type SecondaryNavigation as SecondaryNavigationType } from "./types";
import { forwardRef, useEffect } from "react";
import { SECONDARY_NAV_ID } from "../StickyNavigation/constants";

export type SecondaryNavigationProps = SecondaryNavigationType;

const SecondaryNavigation = forwardRef<HTMLElement, SecondaryNavigationProps>(
  (props, ref) => {
    useEffect(() => {
      document.dispatchEvent(new Event("swi:secondary-nav-rendered"));
    }, []);

    return (
      <nav
        aria-label="Complementary"
        ref={ref}
        id={SECONDARY_NAV_ID}
        {...getDataAutomationId("secondary-nav")}
      >
        <div className="hidden lg:block">
          <SecondaryNavigationDesktop {...props} />
        </div>
        <div className="lg:hidden">
          <SecondaryNavigationMobile {...props} />
        </div>
      </nav>
    );
  },
);

SecondaryNavigation.displayName = "SecondaryNavigation";

export default SecondaryNavigation;
